module.exports = __webpack_public_path__ + "img/wz-8-4-6.a527da35.jpg";